module.exports = __webpack_public_path__ + "static/media/stand_02.35ad476a.glb";